<template>
  <div class="schema">
  <script type="application/ld+json">{
    "@context": "http://schema.org",
    "@type": "VideoObject",
    "name": "Invest in loans - Income Marketplace",
    "description": "The safest marketplace for investing in loans. On the Income Marketplace you can invest in loans and effortlessly earn a passive income. Watch the video to find out more!",
    "thumbnailUrl": "https://i.ytimg.com/vi/BDfiz2VVpow/default.jpg",
    "uploadDate": "2020-12-17T09:51:15Z",
    "duration": "PT2M2S",
    "embedUrl": "https://www.youtube.com/embed/BDfiz2VVpow",
    "hasPart": [
      {
        "@type": "Clip",
        "@id": "#How-it-works",
        "name": "How it works",
        "startOffset": 34,
        "endOffset": 45,
        "url": "https://youtu.be/BDfiz2VVpow?t=34"
      },
      {
        "@type": "Clip",
        "@id": "#Buyback-guarantee",
        "name": "Buyback obligation",
        "startOffset": 55,
        "endOffset": 65,
        "url": "https://youtu.be/BDfiz2VVpow?t=55"
      },
      {
        "@type": "Clip",
        "@id": "#Cashflow-buffer",
        "name": "Cashflow buffer",
        "startOffset": 78,
        "endOffset": 92,
        "url": "https://youtu.be/BDfiz2VVpow?t=78"
      },
      {
        "@type": "Clip",
        "@id": "#Earn-passive-income",
        "name": "Earn passive income",
        "startOffset": 102,
        "endOffset": 114,
        "url": "https://youtu.be/BDfiz2VVpow?t=102"
      }
    ]
  }</script>
  </div>
</template>

<script>
export default {
  name: 'PromoVideoSchema'
}
</script>
